import { useContext } from 'react';
import { useMatch } from 'react-router-dom';
import { BrandingContainer } from '@/containers/AppTheming/BrandingContainer';
import { ChatWidgetContainer } from '@/containers/Chat.Widget';
import { ProjectToolsContainer } from '@/containers/GroupProject/Project.Tools.Container';
import { SurveyResponseFilterContainer } from '@/containers/GroupProject/Survey.ResponseFilter.Container';
import { SurveyResponsesContainer } from '@/containers/GroupProject/Survey.ResponsesState.Container';
import { ProjectEntitiesContainer } from '@/containers/Project.Entities';
import { ProjectDetailsContext } from './Context';
import { ProjectContainer } from './Project.Container';
import { ProjectTabs } from './Project.Tabs';

type Props = unknown;

const ProjectTabStateContainer = (props: Props) => {
  const ctx = useContext(ProjectDetailsContext);

  const entities = useMatch({
    path: `/projects/:projectId/entities`,
  });

  const projectId = ctx.query.data?.project?.id;
  const isReady = !!projectId;

  return (
    <SurveyResponsesContainer>
      <SurveyResponseFilterContainer>
        <ProjectEntitiesContainer
          enabled={!!entities && isReady}
          projectId={projectId}>
          <ProjectToolsContainer>
            <ProjectTabs />
          </ProjectToolsContainer>
        </ProjectEntitiesContainer>
      </SurveyResponseFilterContainer>
    </SurveyResponsesContainer>
  );
};

export const ProjectMain = (props: Props) => {

  const enabled = true;

  return (
    <>
      <BrandingContainer>
        <ProjectContainer>
          <ProjectTabStateContainer />
        </ProjectContainer>
        {enabled && <ChatWidgetContainer />}
      </BrandingContainer>
    </>
  );
};

ProjectMain.displayName = 'Project.Main';